module.exports = __webpack_public_path__ + "static/media/41.a58e5220.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/41.jpg
// module id = 574
// module chunks = 0